import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const drawUnderline = keyframes`
  0% {
    stroke-dashoffset: 150;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const UnderlineContainer = styled(Box)(({ align }) => ({
  position: 'relative',
  width: '100%',
  height: '8px',
  display: 'flex',
  justifyContent: align === 'left' ? 'flex-start' : 
                 align === 'right' ? 'flex-end' : 
                 'center'
}));

const StyledSVG = styled('svg')({
  position: 'absolute',
  height: '100%',
  width: '120px',
  '& path': {
    fill: 'none',
    stroke: '#73c043',
    strokeWidth: 3,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeDasharray: 150,
    animation: `${drawUnderline} 1s cubic-bezier(0.4, 0, 0.2, 1) forwards`
  }
});

const AnimatedUnderline = ({ align = 'center', sx = {} }) => {
  return (
    <UnderlineContainer align={align} sx={sx}>
      <StyledSVG viewBox="0 0 120 8" preserveAspectRatio="xMidYMid meet">
        <path d="M5 4 C30 4, 60 4, 90 4 S110 4, 115 4" />
      </StyledSVG>
    </UnderlineContainer>
  );
};

AnimatedUnderline.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  sx: PropTypes.object
};

export default AnimatedUnderline;
